<template>
    <div class="table-responsive">
        <button id="createModal_item_add" class="form-control glyphicon glyphicon glyphicon-plus" type="button" v-on:click="appendItem()" />
        <button id="createModal_item_delete" class="form-control glyphicon glyphicon glyphicon-minus" type="button" v-on:click="deleteItem()" />
        <table class="table table-responsive">
            <thead>
            <th>ID</th>
            <th>SKU</th>
            <th>{{$t('page.management.avis.quantity')}}</th>
            </thead>
            <tbody id="createModal_items" ref="">
            <tr v-for="(item, index) in items">
                <td>{{index}}</td>
                <td><auto-complete-text-edit :url="url"
                                             :placeholder="placeholder"
                                             :name="name"
                                             v-model="item.sku"
                                             :index="index"></auto-complete-text-edit></td>

                <td><input type="text" name="quantity[]" :placeholder="$t('page.management.avis.quantity')" class="form-control" /></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "AvisItemAppend",
        data: function() {
            return {
                items: []
            }
        },
        props: {
            placeholder: String,
            name: String,
            url: String,
        },
        methods: {
            appendItem: function () {
                this.items.push({sku: "", quantity: 1})
            },
            deleteItem: function () {
                this.items.pop();
            }
        }

    }
</script>

<style scoped>

</style>